import React from 'react';

export const ContentWrapper: React.FC<any> = ({children, className}) => {
    return (
        <div className={`mx-3 md:mx-6 lg:mx-auto lg:px-4 max-w-screen-lg ${className || ''}`}>
            {children}
        </div>
    )
}